

//import { getBase64ID,  getDeviceID } from '../../api/helpers';
//getObjectByID, getIndexByID, deleteItemByID,
//import { base64toGuid, base64ToUint8Array, uint8ArrayToBase64 } from '../../api/helpers';

import { getBase64ID, getObjectByID, getIndexByID, deleteItemByID, getDeviceID } from '../../api/helpers';
import { base64toGuid, base64ToUint8Array, uint8ArrayToBase64 } from '../../api/helpers';


//FLEET_DATA_OP_TYPE
const OP_INITIALIZE = 0
const OP_ADD = 1
const OP_REMOVE = 2
const OP_CHANGE = 3

export const DATA_OP_TYPE = {
    OP_INITIALIZE: 0,
    OP_ADD: 1,
    OP_REMOVE: 2,
    OP_CHANGE: 3
}

//FLEET_TYPES
//const TYPE_UNKNOWN = 0
const TYPE_DEVICES = 10
const TYPE_USERS = 11
const TYPE_GROUPS = 12
const TYPE_STATUSES = 13
//const TYPE_PASSWORD = 14
const TYPE_LOCATION_REQUESTS = 15
const TYPE_QUERYAVATAR = 20
const TYPE_AVATARRESPONSE = 21
//const TYPE_QUERYLOGO = 22
//const TYPE_LOGORESPONSE = 23
//const TYPE_ADDITIONAL_FIELDS = 24
const TYPE_FIELD_TEMPLATES = 24
//const TYPE_MEDIA_CONTROL = 25
const TYPE_EMERGENCY_PROFILES = 30
const TYPE_NETWORKS = 100
const TYPE_NETWORKSETTINGS = 110
const TYPE_NEWNETWORKSETTINGS = 120
const TYPE_SERVERSETTINGS = 130
//const TYPE_COMPOUND = 255

export const EXTERNAL_PROTOCOL_TYPES = {
    EXCERA: 1,
    HYTERA: 2,
    KIRISUN: 3,
    CALTTA: 4
} 



export class ServerApi {

    constructor(serveraddress, login, password, options){

        if(!serveraddress) serveraddress = window.location.host

        this.serveraddress = serveraddress
        this.login = login
        this.password = password
        this.userID = null
        this.connectCount = 0

        this.serverVersion = ''

        this.options = {
            onError: null,
            onClose: null,
            onConnect: null,
            onNetworksChanged: null,
            ...options
        }


        this.onGetnetComplete = null
        this.onGetNewNetworkSettings = null

        this.onCreateNetworkComplete = null
        this.onCreateNetworkCompleteNetworkID = null

        this.onGetServerSettingsComplete = null

        this.onGetLicenses = null

        this.onSrvLinkControl = null  //SRV_LINK_CONTROL

    }


    clearState(){

    }

    connect(){
        if ("WebSocket" in window) {
            this.isClosed = false
            this.connectCount++
            console.log("ws://" + this.serveraddress)

            let protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'

            this.ws = new WebSocket(protocol + "//" + this.serveraddress);

            console.log('create websocket: '+ protocol + "//" + this.serveraddress)

            this.ws.onopen = this.handleOpen.bind(this)
            this.ws.onmessage = this.handleMessage.bind(this)
            this.ws.onerror = this.handleError.bind(this)
            this.ws.onclose = this.handleClose.bind(this)

        } else {
            // The browser doesn't support WebSocket
            alert("WebSocket NOT supported by your Browser!");
        }
    }//end connect

    close(){
        this.isClosed = true
        this.ws.close();
    }


    handleOpen() {
        this.connectCount = 1

        this.initPing()
    }

    handleError(event) { 
        console.error('SOCKET_ERROR')
        console.error(event)
        if(this.options.onError){
            this.options.onError(event, this.connectCount)
        }else{
            alert("Socket error: " + JSON.stringify(event, null, 4)); 
        }
    };


    handleClose(event) { 
        console.log('SOCKET_CLOSE ' + event.code)
        console.log(event)

        this.resetPing()

        if(this.isClosed) return //regular logout

        //closed by server or broken connnection
        if(event.code===1005){
            //server halt
            this.clearState()
            window.setTimeout(()=>{this.connect()}, 5000)
        }else if(event.code===1006){
            window.setTimeout(()=>{this.connect()}, 5000)
        }

        if(this.options.onClose){
            this.options.onClose(event, this.connectCount)
        }else{
            alert("Socket closed. Code: "+event.code);	
        }
    };


    handleMessage(event) { 
        //console.log('event.data')
        //console.log(event.data)
        var messages = JSON.parse(event.data);

        this.processPong()

        for(let mi = 0; mi < messages.length; mi++){
            var msg = messages[mi];
            //console.log('handleMessage '+ mi + ' ' + Date.now())
            //console.log('MessageID=' + msg.MessageID)
            switch(msg.MessageID){
                case "SERVER_CONFIG":
                    this.VoipPort = msg.VoipPort;
                    this.AudioSampleRate = msg.AudioSampleRate;
                    this.AudioBitRate = msg.AudioBitRate;
                    this.AudioFrameSize = msg.AudioFrameSize;
                    
                    this.bufferSamplesCount = this.AudioSampleRate / 1000 * this.AudioFrameSize;
                    //bufferSamplesCount = this.AudioSampleRate / 1000 * this.AudioFrameSize;
                    //udpPacketBuffer = new ArrayBuffer(12 + this.bufferSamplesCount); // aLaw, muLaw

                    //currentFrame = new Int16Array(this.bufferSamplesCount);
                    //currentBufferIndex = 0;

                    //VoipEndpoint = new IPEndPoint(ServerIPAddr, VoIPPort);
                    //rtpPacket = new RtpPacket { Version = 2, SSRC = ssrc, PayloadType = 106, SequenceNumber = 0, Timestamp = 0 };
                    this.ssrc = new Uint32Array(1);
                    window.crypto.getRandomValues(this.ssrc);
                    var devconf = [{ 
                        MessageID: "DEVICE_CONFIG",  
                        Ssrc: this.ssrc[0], 
                        AppName: "RemoteServerManager", 
                        //VersionName: "5.5", 
                        VersionName: this.options.config.version,
                        VersionCode: 1, 
                        AudioCodec: 1, 
                        VoiceOverTcp : "True", 
                        Password: this.password, 
                        DeviceData: { 
                            SessionID: getBase64ID(), 
                            ID: getDeviceID(), 
                            DeviceDescription: "MANUFACTURER=WLLC;MODEL=APIClientWEB;SERIAL=123456789;OSVERSION=5.0", 
                            Login: this.login, 
                            AvatarHash: "", 
                            VoiceOverTcp: true,
                            StatusID: "AAAAAAAAAAAAAAAAAAAAAA==" 
                        }
                    }];
                    console.log('DEVICE_CONFIG')
                    console.log(devconf)
                    this.ws.send(JSON.stringify(devconf));
                    break;

                case "CONFIG_SERVER_RESPONSE_NACK":
                    console.log('CONFIG_SERVER_RESPONSE_NACK')
                    console.log(msg)
                    if(this.options.onError){
                        this.options.onError(msg.Reason)
                    }else{
                        alert(msg.Reason);
                    }
                    break;

                case "CONFIG_SERVER_RESPONSE_ACK":
                    /*
                    if(this.options.onConnect){
                        this.options.onConnect(); 
                    }
                    */
                    //console.log('CONFIG_SERVER_RESPONSE_ACK')
                    //console.log(msg)

                    this.serverVersion = msg.ServerVersion

                    var loginMessage = [{ MessageID: "LOGIN"}];
                    this.ws.send(JSON.stringify(loginMessage));
                    break;

                case "PING":
                    this.sendPong()
                    break;

                case "PONG":
                    break;

                case "LOGIN_RESPONSE":
                    console.log(msg)
                    if(msg.Response === 0){
                        this.userID = msg.UserID 
    
                        if(this.options.onConnect){
                            this.options.onConnect(); 
                        }

                        /*
                        this.audio = new AudioProcessor(
                            this.AudioSampleRate, 
                            this.bufferSamplesCount, 
                            this.ssrc,
                            this.sendVoicePacket.bind(this)
                        );
                        */
                    }else{
                        let message = '';
                        switch(msg.Response){
                            //case 0: message = 'Successful login'; break;
                            case 1: message = 'Invalid client version'; break;
                            case 2: message = 'Invalid user name or password'; break;
                            case 3: message = 'License is expired'; break;
                            case 4: message = 'Exceeded number of available user connections'; break;
                            case 5: message = 'Server working in demo mode must be restarted'; break;
                            case 6: message = 'Multiple logins are prohibited for this user and ' +
                                'another device is already connected with these credentials'; break;
                            default: 
                                message = "Action not defined for "+ msg.Response + " (LOGIN_RESPONSE)"
                                console.error(message)
                        }
                        this.options.onError({message: message, type: 'login'})
                        //alert('login fail with: '+ message)
                    }
                    break;
                
                case "DEVICE_CONTEXT":
                    console.log('DEVICE_CONTEXT')
                    console.log(msg)
                    if(this.options.onAction){
                        this.options.onAction({type:'SET_LANGUAGE', lang: msg.WebLocale})
                    }
                    //alert(msg.WebLocale)
                    //todo?
                    //this.
                    break;
                    
                case 'LICENSE_INFO_RESPONSE':
                    console.log('LICENSE_INFO_RESPONSE')
                    console.log(msg)

                    if(this.onGetLicenses){
                        //console.log('this.onGetLicenses(msg.Licenses)')
                        //console.log(msg.Licenses)
                        this.onGetLicenses(msg.Licenses)
                    }else if(this.options.onAction){
                        //console.log('onAction.SET_LICENSES(msg.licenses)')
                        this.options.onAction({type:'SET_LICENSES', licenses: msg.Licenses})
                    }
                    break
                    
                case "DATAEX":
                    console.log('DATAEX msg type' + msg.DataType)
                    console.log(msg)

                    switch(msg.DataType){
                        
                        case TYPE_NETWORKS:
                            this.processNetworks(msg.DataObjects, msg.Operation);
                            break

                        case TYPE_FIELD_TEMPLATES:
                            //this.processFealdTemplates(msg.DataObjects, msg.Operation)
                            break

                        case TYPE_NETWORKSETTINGS:{
                            const networkSettings = msg.DataObjects[0];
                            console.log('onGetnetComplete TYPE_NETWORKSETTINGS')
                            console.log(networkSettings)
                            this.onGetnetComplete(networkSettings);
                            break
                        }

                        case TYPE_NEWNETWORKSETTINGS:{
                            const newNetworkSettings = msg.DataObjects[0];
                            //console.log('newNetworkSettings')
                            //console.log(newNetworkSettings)
                            this.onGetNewNetworkSettings(newNetworkSettings);
                            break
                        }

                        case TYPE_SERVERSETTINGS:{
                            const serverSettings = msg.DataObjects[0];
                            if(this.onGetServerSettingsComplete){
                                this.onGetServerSettingsComplete(serverSettings);
                            }
                            break
                        }

                        default:
                            console.error('Action case not defined for datatype: ' + msg.DataType + ', see console log for more details')
                            console.error(msg)
                        
                    }



                    break;

                case 'SIMPLE_MESSAGE':
                    console.log('SIMPLE_MESSAGE')
                    console.log(msg)
                    alert(msg.Message)
                    break

                case 'SRV_STATE':
                    console.log('SRV_STATE')
                    console.log(msg)
                    break 


                case 'SRV_LINK_CONTROL':

                    if(this.onSrvLinkControl){

                        console.log('SRV_LINK_CONTROL')
                        console.log(msg)

                        this.onSrvLinkControl(msg.ExternalServer, msg.OpType)

                    }else{
                        alert('empty handler')
                    }

                    break

                default:
                    console.error('Action case not defined for message: ' + msg.MessageID + ', see console log for more details')
                    console.error(msg)
            }
        }
    }

    initPing(){

        this.pingTimer = setInterval(() => {
            
            this.sendPing()

            //test timeout
            if(this.pongTime){
                const diff = Date.now() - this.pongTime
                if(diff>30000){
                    this.ws.close();
                }
            }

        }, 5000);

    }

    resetPing(){
        this.pongTime = 0
        clearTimeout(this.pingTimer)
    }


    sendPing(){
        console.log('send ping manager ' + Date.now())
        const message = [{ 
            MessageID: "PING"
        }];
        this.ws.send(JSON.stringify(message));
    }

    sendPong(networkID){
        const message = [{
            MessageID: "PONG"
        }];
        this.ws.send(JSON.stringify(message));
    }

    processPong(){
        this.pongTime = Date.now()
    }


    processNetworks(nets, dataOp){
        if (dataOp === OP_INITIALIZE || dataOp===OP_INITIALIZE) this.networks = [];

        for (let i = 0; i < nets.length; i++){
            let net = nets[i];

            switch (dataOp) {
                case OP_INITIALIZE:
                case OP_ADD:
                    this.networks.push(net)

                    if(this.onCreateNetworkCompleteNetworkID==base64toGuid(net.ID)){
                        if(this.onCreateNetworkComplete && this.onCreateNetworkComplete()){

                            this.onCreateNetworkCompleteNetworkID = null
                            this.onCreateNetworkComplete = null

                        }
                        //alert('Network Add Complete')
                    }
                    break;
                case OP_CHANGE:{
                    const index = getIndexByID(net.ID, this.networks)
                    if(index!==null) this.networks[index] = net;
                    break 
                }
                case OP_REMOVE:{
                    deleteItemByID(net.ID, this.networks)
                    break
                }
                default:
                    const msg = 'Operation case not defined: ' + dataOp + ', see console log for more details'
                    console.error(msg)
            }
        }

        if(this.options.onNetworksChanged){
            this.options.onNetworksChanged(this.networks)
        }
        console.log('NETWORKS CHANGED:')
        console.log(this.networks)

    }

    getVersion(){
        return this.serverVersion
    }

    //external server links
    externalServerLinkControl(externalServer, opType){
        let message = [{
            MessageID: "SRV_LINK_CONTROL",
            Type: 4,
            OpType: opType,
            ExternalServer: externalServer
        }];
        console.log('SRV_LINK_CONTROL externalServerLinkControl()')
        console.log(message)
        this.ws.send(JSON.stringify(message));
    }

    externalServerLinkControlRegisterCallback(callback){

        console.log('externalServerLinkControlRegisterCallback')
        this.onSrvLinkControl = callback
    }

    //setup ports settings
    addNetwork(networkID, callback){
        this.onGetNewNetworkSettings = callback
        let message = [{
            MessageID: "SRV_QUERY_NETWORKSETTINGS", 
            ID: networkID,
        }];
        this.ws.send(JSON.stringify(message));
    }


    createNetwork(settings, callback){
        this.onCreateNetworkComplete = callback
        this.onCreateNetworkCompleteNetworkID = settings.ID
        let message = [{
            MessageID: "SRV_CREATE_NETWORK", 
            ...settings
        }];
        console.log('createNetwork')
        console.log(message)
        this.ws.send(JSON.stringify(message));
    }


    startNetwork(networkID){
        let message = [{
            MessageID: "SRV_START_NETWORK", 
            ID: networkID,
        }];
        console.log('send startNetwork')
        console.log(message)
        this.ws.send(JSON.stringify(message));
    }

    stopNetwork(networkID){
        let message = [{
            MessageID: "SRV_STOP_NETWORK", 
            ID: networkID,
        }];
        console.log('send stopNetwork')
        console.log(message)
        this.ws.send(JSON.stringify(message));
    }

    deleteNetwork(networkID){
        let message = [{
            MessageID: "SRV_DELETE_NETWORK", 
            ID: networkID
        }];
        console.log('send stopNetwork')
        console.log(message)
        this.ws.send(JSON.stringify(message));
    }

    queryGetNetworkSettings(networkID, onComplete){
        console.log('queryGetNetworkSettings ' + networkID)
        const getnetMessage = [{ MessageID: "SRV_GET_NETWORKSETTINGS", ID: networkID}];
        this.ws.send(JSON.stringify(getnetMessage));
        this.onGetnetComplete = onComplete;
    }

    querySaveNetworkSettings(NetworkData, NetworkSettings, onComplete){
        const saveNetworkMessage = [{ 
            MessageID: "SRV_SET_NETWORKSETTINGS",
            NetworkData: NetworkData,
            NetworkSettings: NetworkSettings
        }]
        console.log('querySaveNetworkSettings')
        console.log(saveNetworkMessage)
        this.ws.send(JSON.stringify(saveNetworkMessage));
    }

    queryGetServerSettings(onComplete){
        console.log('queryGetServerSettings')
        const getNetMessage = [{ MessageID: "SRV_GET_SERVERSETTINGS"}];
        this.ws.send(JSON.stringify(getNetMessage));
        this.onGetServerSettingsComplete = onComplete;
    }
    
    querySaveServerSettings(serverSettings){
        const saveServerSettingsMessage = [{ MessageID: "SRV_SET_SERVERSETTINGS", ...serverSettings}]
        console.log('querySaveServerSettings')
        console.log(saveServerSettingsMessage)
        this.ws.send(JSON.stringify(saveServerSettingsMessage));
    }


    queryLicenses(callback){

        this.onGetLicenses = callback

        const getLicensesMessage = [{ MessageID: "LICENSE_INFO_REQUEST"}]
        //console.log('getLicensesMessage')
        //console.log(getLicensesMessage)
        this.ws.send(JSON.stringify(getLicensesMessage));
    }


    //////////////////////////////////////
    // Permissions api
    //////////////////////////////////////

    checkPermission (networkID, permission){

        //return true;

        const net = getObjectByID(networkID, this.networks)  
        if(!net) return null;

        //console.log('checkPermission')
        //console.log(networkID)
        //console.log(net)

        console.log('permission =' + permission)
        //debugger
        let allowed
        if(permission>=4294967296){
            permission = permission/4294967296;
            allowed =  net.AllowedOps2 & permission 
        }else{
            allowed =  net.AllowedOps & permission
        }

        //console.log('permission =' + permission)
        //console.log('AllowedOps='+net.AllowedOps)
        //console.log('AllowedOps2='+net.AllowedOps2)
        //console.log('allowed')
        //console.log(allowed)

        return allowed === permission;

    }

    
}